<template>
  <div>
    <v-row>
      <v-col cols="12">
        <router-link :to="linkBack" style="text-decoration: none" title="Back">
          <v-btn
            color="warning"
            fab
            small
            dark
            style="float: left; margin-left: 5px"
          >
            <v-icon class="fa fa-arrow-left"></v-icon>
          </v-btn>
        </router-link>

        <button
          class="btn btn-lg btn-success"
          @click="saveData"
          style="text-align: center"
          v-if="showBtn == true && countVariants <= 100"
        >
          Create
        </button>
        <button
          class="btn btn-lg btn-success"
          style="text-align: center"
          v-else
          disabled
        >
          Create
        </button>
        <!-- <button class="btn btn-lg btn-success" @click="check" style="text-align:center">Check</button> -->
        <div>
          <v-col cols="12">
            <template v-if="inform == true">
              <!-- <b style="color:green">{{informText}}</b> -->
              <v-alert type="success">
                {{ informText }}
              </v-alert>
            </template>
            <template v-else-if="inform == false">
              <!-- <b style="color:red">{{informText}}</b> -->
              <v-alert type="error">
                {{ informText }}
              </v-alert>
            </template>
          </v-col>
        </div>
      </v-col>
    </v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="6">
          <preview :product_id="productData.product_id" />
        </v-col>

        <v-col cols="6">
          <v-text-field
            v-model="productData.title"
            :rules="rules"
            counter
            dense
            outlined
            maxlength="200"
            hint="Title less than 200 characters"
            label="Product Title"
            @keyup="validation"
          ></v-text-field>

          <v-text-field
            v-model="productData.amazon_title"
            :rules="rules"
            counter
            dense
            outlined
            maxlength="200"
            hint="Title less than 200 characters"
            label="Amz Product Title"
            @keyup="validation"
          ></v-text-field>

          Add Tags
          <!-- <multiselect v-model="tagSelected" placeholder="Select Tag" label="tag_name" track-by="tag_name"
                    :options="listTags" :multiple="true" :taggable="true" @tag="addTag"></multiselect> -->

          <v-autocomplete
            v-model="productData.tags"
            :items="listTags"
            :item-text="(obj) => obj.showName"
            :item-value="(obj) => obj._id"
            outlined
            dense
            chips
            small-chips
            label="Select Tags"
            multiple
            @input="searchInput = null"
            :search-input.sync="searchInput"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12" class="border">
      <v-row>
        <v-col cols="4">
          <v-select
            :items="listProductTypes"
            :item-text="(obj) => obj.product_type"
            :item-value="(obj) => obj._id"
            outlined
            dense
            v-model="product_type_id"
            label="Select Product Type"
          ></v-select>
        </v-col>
        <v-col cols="2">
          <button
            class="btn btn-primary btn-md"
            @click="
              assignVariants();
              validation();
            "
            v-if="product_type_id && roles.update_crawled_product_info"
          >
            Assign Variant
          </button>
          <button class="btn btn-primary btn-md" v-else disabled>
            Asign Variant
          </button>
          <!-- <button @click="check">Check</button> -->
        </v-col>
      </v-row>

      <v-col cols="12" v-if="listFilter.length > 0" class="border">
        <v-row>
          <v-col cols="3" v-for="(i, index) in listFilter" :key="index">
            <v-autocomplete
              v-model="listFilterSelected[i.name]"
              :items="i.data"
              outlined
              dense
              chips
              small-chips
              :label="i.name"
              multiple
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-btn @click="filterData" color="success">Filter Variants</v-btn>
            &nbsp;
            <!-- <v-btn @click="filterDelete" dark v-if="showDelBtn" color="red">Delete All Remaining Variants</v-btn> -->
          </v-col>
        </v-row>
      </v-col>
      <v-row>
        <v-col cols="12">
          <template v-if="countVariants > 100">
            <b style="color: red">{{ countVariants }} selected variant(s)</b>
          </template>
          <template v-else> {{ countVariants }} selected variant(s) </template>
          <table width="100%" class="table table-striped">
            <thead class="thead-light">
              <tr>
                <th></th>
                <th>Mockup</th>
                <th v-for="i in headers" :key="i">
                  {{ i }}
                </th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(i, index) in listVariants">
                <tr :key="i.variant_id" v-show="i.selected">
                  <td>
                    <v-checkbox v-model="i.selectToAssignMockup" @change="updateListVariantsMockup(i)"></v-checkbox>
                  </td>
                  <td>
                    <img :src="i.assignedMockup" style="width:100px"/>
                  </td>
                  <td v-for="j in i.options" :key="j.name">
                    <input
                      type="text"
                      class="form-control"
                      v-model="j.value"
                      disabled
                    />
                  </td>
                  <td>
                    <v-btn
                      color="orange"
                      dark
                      small
                      @click="deleteVariant(index)"
                      v-if="roles.update_crawled_product_info"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </v-col>

        <BaseDialog :active.sync="dialogMockup" dialog_name="Assign mockup to variant(s)">
          <addMockup
            :listVariants="listAddMockup"
            :listMockup="productData.preview_imgs"
          />
        </BaseDialog>

        <div class="btnCorner">
          <v-btn color="purple" dark @click="dialogMockup = !dialogMockup" v-if="listAddMockup.length > 0">ASSIGN MOCKUP ({{ listAddMockup.length }})</v-btn>
          &nbsp;
          <v-btn color="teal" dark @click="clearListVariantsMockup()" v-if="listAddMockup.length > 0">CLEAR SELECTED ({{ listAddMockup.length }})</v-btn>
        </div>
      </v-row>

      <div class="btnCorner">
        <v-btn color="purple" dark @click="dialogMockup = !dialogMockup" v-if="listAddMockup.length > 0">ASSIGN MOCKUP ({{ listAddMockup.length }})</v-btn>
        &nbsp;
        <v-btn color="teal" dark @click="clearListVariantsMockup()" v-if="listAddMockup.length > 0">CLEAR SELECTED ({{ listAddMockup.length }})</v-btn>
      </div>
      
    </v-col>
  </div>
</template>

<script>
import preview from "./c-image-preview";
import axios from "axios";
import Amplify, { Auth } from "aws-amplify";
import addMockup from "./c-dialog-create-crawled-add-mockup.vue"
import BaseDialog from "../Common/c-base-dialog";
//import Multiselect from 'vue-multiselect'

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  components: {
    //design,
    preview,
    addMockup,
    BaseDialog,
  },

  data: () => ({
    listImagePreview:[],

    listAddMockup:[],
    searchInput: null,
    inform: null,
    informText: "",
    showBtn: false,

    dialogMockup: false,
    linkBack: "",
    productData: {
      product_id: "",
      title: "",
      amazon_title: "",
      preview_imgs: [],
      tags: [],
      product_type_id: "",
      variants: [],
    },
    listVariants: [],
    listFilter: [],
    listFilterSelected: [],
    countVariants: 0,
    headers: [],

    product_type_id: "",
    rules: [(v) => v.length <= 200 || "Max 200 characters"],
    listProductTypes: [],
    listTags: [],

    roles: [],
  }),

  created() {
    this.$root.$refs.crawledCreate = this;
  },

  watch: {
    listVariants: function () {
      return this.listVariants;
    },
  },

  methods: {
    //validation
    validation() {
      if (
        this.productData.title.length <= 200 &&
        this.countVariants > 0 &&
        this.countVariants <= 100 &&
        this.productData.preview_imgs.length > 0
        // &&
        // this.productData.tags.length > 0
      ) {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    },

    //test
    check() {
      console.log("productData: ", this.productData);
      console.log("listVariants: ", this.listVariants);
    },

    //tag

    //assign variants to productData
    assignVariants() {
      this.listVariants.length = 0;
      this.headers.length = 0;
      this.listFilterSelected = [];

      for (let t = 0; t < this.listProductTypes.length; t++) {
        if (this.listProductTypes[t]._id == this.product_type_id) {
          for (const j of this.listProductTypes[t].option_names) {
            this.headers.push(j);
          }
        }
      }

      for (let i = 0; i < this.listProductTypes.length; i++) {
        if (this.listProductTypes[i]._id == this.product_type_id) {
          for (const u of this.listProductTypes[i].variants) {
            u["selected"] = true;
            u["selectToAssignMockup"] = false
            u["assignedMockup"] = null
            this.listVariants.push(u);
          }
        }
      }
      this.countVariants = this.listVariants.length;
      //console.log(this.listVariants);
      this.loadFilter();
    },

    //filter
    loadFilter() {
      this.listFilter = [];
      for (const i of this.headers) {
        var temp = {
          name: i,
          data: [],
        };

        var tempData = new Set();

        for (const j of this.listVariants) {
          for (const k of j.options) {
            if (k.name == i) {
              tempData.add(k.value);
            }
          }
        }

        var tempData2 = Array.from(tempData);
        for (const l of tempData2) {
          temp.data.push(l);
        }
        this.listFilter.push(temp);
      }
      this.validation();
    },

    filterData() {
      this.countVariants = 0;
      for (const x of this.listVariants) {
        x.selected = true;
      }
      for (const i of this.headers) {
        if (
          this.listFilterSelected[i] != undefined &&
          this.listFilterSelected[i].length > 0
        ) {
          var tempX = [];
          for (const k of this.listVariants) {
            if (k.selected == true) {
              for (const l of k.options) {
                if (i == l.name) {
                  for (const j of this.listFilterSelected[i]) {
                    if (j == l.value) {
                      tempX.push(k);
                    } else {
                      k.selected = false;
                    }
                  }
                }
              }
            }
          }
        }

        if (tempX != undefined) {
          this.countVariants = tempX.length;
          for (const a of tempX) {
            for (const b of this.listVariants) {
              if (a.variant_id == b.variant_id) {
                b.selected = true;
                break;
              }
            }
          }
        }
      }

      var temp = [];
      this.listVariants.push(temp);
      this.listVariants.splice(this.listVariants.length - 1, 1);

      if (this.countVariants == 0) {
        for (const i of this.listVariants) {
          i.selected = false;
        }
      }

      this.validation();
    },

    deleteVariant(index) {
      this.countVariants = 0;
      this.listVariants[index].selected = false;
      for (const i of this.listVariants) {
        if (i.selected == true) {
          this.countVariants += 1;
        }
      }
      this.validation();
    },

    //imagePreview

    changeImgPosition(array) {
      if (array != "") {
        //this.showBtn = true;
        this.productData.preview_imgs = array;
        this.validation();
      } else {
        this.showBtn = false;
      }
    },

    //save+loadData

    async loadData() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "crawl-product-create-loadData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "personalize-products/get-data", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("response: ", response);

            this.listProductTypes = response.data.data.productTypes;
            this.listTags = response.data.data.tags_v2;
            this.productData.product_id = response.data.data.product_id;

            for (var i of this.listTags) {
              i["showName"] =
                i.niche_classifier.join(" > ") + " > " + i.tag_name;
            }
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log(
          "currentSession crawl-product-create-loadData-undefined: ",
          currentSession
        );
      }
    },

    async saveData() {
      this.showBtn = false;
      var check = true;

      if (this.productData.title.length >= 200) {
        check = false;
      }

      if (check == true) {
        this.productData.variants = [];
        for (const i of this.listVariants) {
          if (i.selected == true) {
            var h = {
              variant_id: i.variant_id,
              mockup_url: null,
            };
            if(i.assignedMockup){
              h.mockup_url = i.assignedMockup
            }
            this.productData.variants.push(h);
          }
        }

        this.productData.product_type_id = this.product_type_id;

        console.log("this.productData: ", this.productData);
        var currentSession = await this.$root.$refs.App.currentSession(
          "crawl-product-create-saveData"
        );

        if (currentSession.accessToken) {
          await fetch(window.domain + "products", {
            method: "POST",
            headers: {
              Authorization: currentSession.accessToken,
            },
            body: JSON.stringify(this.productData),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("crawl-product-create-response: ", data);
              if (data.error_message == "") {
                this.$router.push(this.linkBack);
              } else {
                this.inform = false;
                this.informText = data.error_message;
              }
              //this.loadData()
            })
            .catch((error) => {
              console.log("error ", error);
            });
        } else {
          console.log(
            "currentSession crawl-product-create-saveData-undefined: ",
            currentSession
          );
        }
      } else {
        this.inform = false;
        this.informText = "Title less than 200 characters";
      }

      //   await this.sleep(3000);
      //   this.informText = "";
      //   this.inform = null;
      //   this.showBtn = true;
    },

    
    updateListVariantsMockup(item){

      if(item.selectToAssignMockup){
        this.listAddMockup.push(item)
      }else{
        let index = this.listAddMockup.indexOf(item)
        this.listAddMockup.splice(index,1)
      }
      //console.log("item: ",item," - this.listAddMockup: ",this.listAddMockup)
      },

    clearListVariantsMockup(){
      this.listAddMockup.map(t => {
        t.selectToAssignMockup = false
        return t
      })
      this.listAddMockup = []
    },

    assignMockupToVariants (url){
      this.listAddMockup.map(t => {
        t['assignedMockup'] = url
        return t
      })
      this.clearListVariantsMockup()
      this.dialogMockup = false
      
    }
  },

  async mounted() {
    this.roles = await this.$cookies.get("crawled_product");
    this.params = window.location.search;
    this.linkBack = "/products" + this.params;

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      await this.loadData();
      //this.validation();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
.btnCorner{
  position: fixed;
  bottom: 8px;
  left: 8px; 
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>